module.exports = __webpack_public_path__ + "img/loader.0f8c7134.gif";